import watchNewPragaDoenca from './saga/new';
import watchFindPragaDoenca from './saga/find';
import watchCreatePragaDoenca from './saga/create';
import watchListAllPragaDoenca from './saga/listAll';
import watchListPragaDoenca from './saga/listTable';
import watchDeletePragaDoenca from './saga/delete';
import watchNewFilterPragaDoenca from './saga/newFilter';
import watchNewFilterNextPagePragaDoenca from './saga/newFilterNextPage';
import watchCancelPragaDoencaRapido from './saga/cancel';

export const pragaDoencaSaga = [
    watchNewPragaDoenca(),
    watchFindPragaDoenca(),
    watchCreatePragaDoenca(),
    watchListAllPragaDoenca(),
    watchListPragaDoenca(),
    watchDeletePragaDoenca(),
    watchNewFilterPragaDoenca(),
    watchNewFilterNextPagePragaDoenca(),
    watchCancelPragaDoencaRapido(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
export * from './entity';